import {Action, createAction, props} from '@ngrx/store';
import {Empresa} from '../models/empresa.model';

export const CARGAR_DATOS_EMPRESA = '[Empresa] Cargar datos';
export const BORRAR_DATOS_EMPRESA = '[Empresa] Borrar datos';


export const cargarEmpresa = createAction(
  CARGAR_DATOS_EMPRESA,
  props<Empresa>()
);

export const borrarEmpresa = createAction(
  BORRAR_DATOS_EMPRESA
);
